import { connectAppStore } from "../../Store/AppStore";
import PageDependencies from "../../Feature/PageDependencies";
import AdminCreditDataTable from "./AdminCreditDataTable";

const Credits = (props) => {
    const { 
        Fragment,
        useEffect,
        useState,
        useParams,
        layoutManager,
        useReducerSmart,
        getAppStore,
        pageProfile,
        tryCatchFinally,
        getData,
        toastPrint,
        AppLoading,
        loaModelFromApi,
    } = PageDependencies();
    const debug = layoutManager.Layout_GetDebugModel(props);
    const defaultParams = pageProfile.getDefaultParams(useParams());
    const [init, setInit] = useState(false);
    const { id } = defaultParams;
    const defaultViewModel = {
        ...defaultParams,
    };
    const [extraPostModel, setExtraPostModel] = useState({
        userId: id
    });
    const [viewModel, dispatchViewModel, bindingViewModel] = useReducerSmart(defaultViewModel);
    const [credits, setCredits] = useState({
        certificateCredits: 0,
        simulationCredits:0
    });
    const loadCredits = async (userId)=>{
        await tryCatchFinally.asyncProcess(async ()=>{
            const getResponse = await getData.processPost(true, "api/CreditAdmin/GetCreditsAmount", {userId: userId});
            if (!getResponse.state) {
                toastPrint.printResponse(getResponse);
                return;
            }
            setCredits({
                certificateCreditsNewHome: getResponse.certificateCreditsNewHome,
                certificateCreditsExistingHome: getResponse.certificateCreditsExistingHome,
                simulationCredits: getResponse.simulationCredits
            });
        });
    }
    const [loading, setLoading] = useState({ isLoading: false, text: "" });
    const [appStoreState, appStoreDispatch] = getAppStore(props);
    const getUrl = "api/CreditAdmin/Get";
    const [reloadForm, setReloadForm] = useState("");
    const [data, setData] = useState([]);

    useEffect(()=>{
        layoutManager.Layout_HideHeadterButton_Footer_HideSideBar(props);
        loaModelFromApi.loadDefault(true, getUrl, viewModel, dispatchViewModel, setLoading, "Loading User's Credits", appStoreDispatch, (newModel)=>{
            loadCredits(newModel.userId);
        }, setInit);
    },[]);

    return (
        <Fragment>
            {debug && <p>{JSON.stringify(viewModel)}</p>}
            {loading.isLoading && (<AppLoading active><div>{loading.text}</div></AppLoading>)}
            <div className="app-main__inner">
                <div className="app-page-title">
                    <div className="page-title-wrapper">
                        <div className="page-title-heading">
                            <div className="page-title-icon">
                                <i className="pe-7s-credit icon-gradient bg-tempting-azure">
                                </i>
                            </div>
                            <div>
                                User Credits for {viewModel.userInfo}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="main-card mb-3 card">
                    <div data-parent="#simulationCredits" id="simulationCreditsDiv3" className="collapse show">                     
                        <div className="card-body">
                            <div className="page-title-heading">                           
                                <div>
                                    <h5>Simulation Credits: {credits.simulationCredits}</h5>
                                </div>
                            </div>                                               
                        </div>
                    </div>
                </div>
                <div className="main-card mb-3 card">
                    <div data-parent="#certificateCreditsNewHome" id="certificateCreditsNewHomeDiv2" className="collapse show">                     
                        <div className="card-body">
                            <div className="page-title-heading">                           
                                <div>
                                    <h5>Certificate Credits (New Home / Thermal Only): {credits.certificateCreditsNewHome}</h5>
                                </div>
                            </div>                                           
                        </div>
                    </div>
                </div>
                <div className="main-card mb-3 card">
                    <div data-parent="#certificateCreditsExistingHome" id="certificateCreditsExistingHomeDiv2" className="collapse show">                     
                        <div className="card-body">
                            <div className="page-title-heading">                           
                                <div>
                                    <h5>Certificate Credits (Existing Home): {credits.certificateCreditsExistingHome}</h5>
                                </div>
                            </div>                                           
                        </div>
                    </div>
                </div>
                <div className="main-card mb-3 card">
                    <div data-parent="#HeatingConditionersList" id="HeatingConditionersListDiv" className="collapse show">
                        <div className="card-body">
                            <AdminCreditDataTable
                                debug = {debug}
                                data = {data}
                                setData = {setData}
                                extraPostModel = {extraPostModel}
                                url="api/CreditAdmin/GetCredits"
                                tableReload = {reloadForm}
                                setTableReload = {setReloadForm}
                            ></AdminCreditDataTable>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
export default connectAppStore(Credits);
